import { Text, Divider, Box, Flex } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import Lottie from "lottie-react";
import BlockAnimationData from "../../../assets/animations/blockAnimation.json";
import { getTraceDetails } from "../../../Pages/traceability/Pages/api";
import moment from "moment";

const Details = ({ id }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [traceDetails, setTraceDetails] = useState({});

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const res = await getTraceDetails(id);
      setTraceDetails(res.data);
      setIsLoading(false);
    })();
  }, []);

  // styles
  const titleStyle = {
    fontSize: "12px",
    color: "gray",
  };

  const dataStyle = {
    fontSize: "14px",
    color: "black",
    wordBreak: "break-all",
    overflowWrap: "break-word",
  };

  const detailsData = [
    {
      title: "Issue Date",
      data: moment(traceDetails?.tcIssuedAt).format("MMMM Do YYYY, h:mm:ss a"),
    },
    {
      title: "Issuer",
      data: traceDetails?.tcIssuer,
    },
    {
      title: "Transaction Id",
      data: traceDetails?.transactionId,
    },
    {
      title: "Hash (SHA256)",
      data: traceDetails?.hash,
    },
  ];

  return (
    <Flex flexDirection={"column"} gap={"1rem"} my={"1rem"} background>
      {isLoading ? (
        <Lottie style={{ height: "8rem" }} animationData={BlockAnimationData} />
      ) : (
        <>
          {detailsData?.map((e, index) => (
            <>
              <Box key={index}>
                <Text {...titleStyle}>{e.title}</Text>
                <Text {...dataStyle}>{e.data}</Text>
              </Box>
              <Divider
                orientation="horizontal"
                borderColor="gray.200"
                borderWidth="1px"
              />
            </>
          ))}
        </>
      )}
    </Flex>
  );
};

export default Details;
